import type { ExpenseType, PaymentMethod } from '@/integrations/api';

/**
 * Expense type options for the Add/Edit forms. The labels mirror ExpenseType.label() on
 * the backend (used in the SharePoint filename), so keep the two in sync. "andet" is the
 * one that reveals the free-text description field.
 */
export const EXPENSE_TYPE_OPTIONS: { value: ExpenseType; label: string }[] = [
  { value: 'frokost', label: 'Frokost' },
  { value: 'mad_paa_lokation', label: 'Mad – på lokation' },
  { value: 'mad_vaek_fra_lokation', label: 'Mad – væk fra lokation' },
  { value: 'faelles_udlaeg', label: 'Fælles udlæg' },
  { value: 'transport', label: 'Transport' },
  { value: 'andet', label: 'Andet' },
];

/**
 * How the expense was paid. "privat" (default) = the employee laid out and must be
 * reimbursed; "firmakort" = company card, no reimbursement, but the receipt is still
 * uploaded. Drives the SharePoint filename tag (Privat/Firma) and the admin firmakort tab.
 */
export const PAYMENT_METHOD_OPTIONS: { value: PaymentMethod; label: string }[] = [
  { value: 'privat', label: 'Privat udlæg' },
  { value: 'firmakort', label: 'Firmakort' },
];

/** Display label for an expense type (falls back to the raw value). */
export function expenseTypeLabel(value: ExpenseType): string {
  return EXPENSE_TYPE_OPTIONS.find((o) => o.value === value)?.label ?? value;
}

/** Short display label for a payment method (e.g. on a badge). */
export function paymentMethodLabel(value: PaymentMethod): string {
  return value === 'firmakort' ? 'Firmakort' : 'Privat';
}
